import React, { useContext } from "react";

import { LiveEventAggregatedScoreSummary } from "@features/offer/shared/event/details";
import { OfferOptionsContext } from "@gp/components";
import { EventOffer, SportOffer } from "@gp/offer";
import { useResultChangeIndicator } from "@state/hooks/offer/useResultChangeIndicator";
import { SERVER_SPORTS } from "@utils/offer/ServerSport";
import classnames from "classnames";
import { observer } from "mobx-react";

export default observer(function LiveEventTimeAndScore({
	sport,
	event,
}: {
	sport: SportOffer | null;
	event: EventOffer;
}) {
	const isServeSport = SERVER_SPORTS.includes(sport?.abrv || "");
	const offerOptions = useContext(OfferOptionsContext);
	const result = useResultChangeIndicator(event, sport, offerOptions);

	const homeTeamClass = classnames("event__middle__home", {
		"is-inc": result.isHomeScore,
	});
	const awayTeamClass = classnames("event__middle__away", {
		"is-inc": result.isAwayScore,
	});

	return (
		<div className="event__middle">
			<div className="event__middle__score">
				{isServeSport && (
					<i
						className={
							"u-icon u-icon--serve" +
							(event.result?.serve === "home" ? " is-active" : "")
						}
					/>
				)}
				<span className={homeTeamClass}>{result.home}</span>
				<span className="event__middle__divider">-</span>
				<span className={awayTeamClass}>{result.away}</span>

				{isServeSport && (
					<i
						className={
							"u-icon u-icon--serve" +
							(event.result?.serve === "away" ? " is-active" : "")
						}
					/>
				)}
			</div>

			<div className="event__middle__time event__middle__time--live">
				{event.matchTime?.displayTime}
			</div>
			<LiveEventAggregatedScoreSummary event={event} />
		</div>
	);
});
